export const APP_NAME = 'Forest';
// TODO: Migrate to `/community`
export const COMMUNITY_PREFIX_PATH = '/app';
export const VENDORLINK_PREFIX_PATH = '/vendor';
export const AUTH_PREFIX_PATH = '/auth';
export const INVITATION_PREFIX_PATH = '/invitations';
export const COMMUNITY_KEY = 'community';
export const ACCOUNT_KEY = 'account';
